import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const CustomCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [active, setActive] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { damping: 28, stiffness: 380, mass: 0.4 });
  const sy = useSpring(y, { damping: 28, stiffness: 380, mass: 0.4 });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia("(pointer:fine)").matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const el = document.elementFromPoint(e.clientX, e.clientY);
      setActive(!!(el && el.closest("[data-cursor='view']")));
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div className="evo-cursor" style={{ x: sx, y: sy }} aria-hidden>
      <motion.div
        className="flex items-center justify-center rounded-full border border-evo-gold text-evo-gold font-sans text-[10px] uppercase tracking-[0.2em]"
        style={{ translateX: "-50%", translateY: "-50%" }}
        animate={{
          width: active ? 76 : 16,
          height: active ? 76 : 16,
          backgroundColor: active ? "rgba(200,169,126,0.14)" : "rgba(200,169,126,0)",
        }}
        transition={{ type: "spring", damping: 22, stiffness: 300 }}
      >
        {active ? "View" : ""}
      </motion.div>
    </motion.div>
  );
};
